module.exports = __webpack_public_path__ + "static/img/right-top-row-1.eb1d5b06.png";